import { render, staticRenderFns } from "./AreaCustomQuestion.vue?vue&type=template&id=af2d450c&"
import script from "./AreaCustomQuestion.vue?vue&type=script&lang=js&"
export * from "./AreaCustomQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports